import Vue from 'vue'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  transitions,
} from 'vuetify'
import { VTab, VTabItem, VTabsItems, VTabsSlider, VTabs } from 'vuetify/es5/components/VTabs';
import { VCard } from 'vuetify/es5/components/VCard';
import { VDataTable } from 'vuetify/es5/components/VDataTable';
import { VMenu } from 'vuetify/es5/components/VMenu';
import 'vuetify/src/stylus/app.styl'
import '@fortawesome/fontawesome-free/css/all.css';

Vue.use(Vuetify, {
  iconfont: 'fa',
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    transitions,
    VTab,
    VTabItem,
    VTabsItems,
    VTabsSlider,
    VTabs,
    VCard,
    VDataTable,
    VMenu
  },
})
